import { render, staticRenderFns } from "./BusinessConsulting.vue?vue&type=template&id=7f264eca&"
import script from "./BusinessConsulting.vue?vue&type=script&lang=js&"
export * from "./BusinessConsulting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports